// extracted by mini-css-extract-plugin
export default {"button":"jm-z","reviewSort":"km-z"};